import { Flex, Table } from "antd";
import { useEffect, useState } from "react";
import axiosInstance from "../axios";
import dayjs from "dayjs";

const Feedback = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 200,
  });
  const [globalFilter, setGlobalFilter] = useState(null);

  useEffect(() => {
    fetchData(pagination.current, pagination.pageSize);
  }, []);

  const fetchData = async (page, limit) => {
    setLoading(true);
    const response = await axiosInstance.get(`/v1/cre/feedback`, {
      params: {
        page,
        limit,
      },
    });
    setData(
      response.data.data?.map((item) => ({
        ...item,
        fullName: `${item.first_name} ${item.last_name}`,
        createdAt: dayjs(item.created_at).format("DD-MM-YYYY HH:mm:ss"),
      }))
    );
    setPagination({
      ...pagination,
      current: page,
      pageSize: limit,
      total: response.data.meta.total,
    });
    setLoading(false);
  };
  const columns = [
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 200,
    },
    {
      title: "Name",
      dataIndex: "fullName",
      key: "fullName",
      width: 200,
    },
    {
      title: "Rating",
      dataIndex: "rating",
      key: "rating",
    },
    {
      title: "feedback",
      dataIndex: "feedback",
      key: "feedback",
    },
  ];

  const handleTableChange = (pagination, filters, sorter) => {
    if (pagination.current) {
      fetchData(pagination.current, pagination.pageSize);
    }
  };
  return (
    <Flex
      style={{
        overflow: "scroll",
        marginLeft: "5px",
      }}
    >
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        pagination={{
          ...pagination,
          onChange: handleTableChange,
          showSizeChanger: true,
          pageSizeOptions: [10, 15, 20, 25, 50, 100, 150, 200, 250, 500],
        }}
        loading={loading}
        onChange={handleTableChange}
      />
    </Flex>
  );
};

export default Feedback;
